export default "__VITE_ASSET__yO63Gjgf__"